module.exports = __webpack_public_path__ + "static/media/handshake-purple.1c71df45.svg";